import { inject } from 'vue';
import { modalKey } from '@/infra/injection-keys';
import type { ModalType } from '../plugins/modal';

export function useModal(): ModalType {
  const modal = inject(modalKey);
  if (!modal) throw new Error('Modal plugin not installed');
  return modal;
}
